export default class User {

    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all() {
        return this.rest.one('user').get();
    };

    find(id) {
        return this.rest.one('user', id).get();
    };

    create(user) {
        return this.rest.all('user').post({ email: user.email, role: user.role });
    };

    update(id, user) {
        return this.rest.one('user', id).customPUT(user);
    };

    remove(user) {
        return this.rest.one('user', user.id).remove();
    };
    
    administrate(accountId) {
        return this.rest.all('user/setAdministratingAccount').post({ accountId: accountId });
    };
    
    logIn(email, password) {
        return this.rest.all('user/login').post({ email: email, password: password });
    };

    logout() {
        return this.rest.one('user/logout').get();
    }
    
    reset(email) {
        return this.rest.all('user/requestReset').post({email: email});
    };
    
    refresh(token) {
        return this.rest.all('user/login/refresh').post({token: token});
    };
};

User.$inject = ['Rest'];
